export var styles = {
  imageListImageWidth: 75
};
export var TEMPLATE_TYPES = {
  EXPANDABLE_LIST: 'expandable-list',
  LIST: 'list',
  IMAGE_LIST: 'image-list',
  IMAGE_GRID: 'image-grid',
  NEXT_STEPS: 'next-steps'
};
export var DEFAULT_IMAGE_SRC = '//cdn.nerdwallet.com/nodeapp/structured-content/simon-hattinga-verschure-5085-unsplash.jpg';